// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","copyright":"Footer_copyright__2wqDr","version":"Footer_version__30hmx"};